// alert('지환스크립트 연결');

// Jquery
$(document).ready(function () {
    var currentPath = window.location.pathname;

    $('.servicemenu li a').each(function () {
      var href = $(this).attr('href');
      if (currentPath === href || currentPath.includes(href)) {
        $(this).addClass('active');
      }
    });
  });

document.querySelectorAll('.servicemenu li').forEach(li => {
  if (li.querySelector('a.active')) {
    li.classList.add('no-after');
  }
});
    
// // 바닐라 JS
// document.addEventListener("DOMContentLoaded", function () {
//   var currentPath = window.location.pathname;

//   var links = document.querySelectorAll('.servicemenu li a');
//   links.forEach(function (link) {
//     var href = link.getAttribute('href');
//     if (currentPath === href || currentPath.includes(href)) {
//       link.classList.add('active');
//     }
//   });
// });

// 서비스 아코디언
document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("shopify-section-{{ section.id }}");
  if (!root) return;

  function closeAllAccordions() {
    root.querySelectorAll("details[is='accordion-details']").forEach(d => {
      if (typeof d.close === "function") {
        d.close();
      } else {
        d.open = false;
      }
    });
  }

  root.querySelectorAll("button[is='next-button'], button[is='previous-button']")
    .forEach(btn => btn.addEventListener("click", closeAllAccordions));

  root.querySelectorAll(".timeline-dots button")
    .forEach(dot => dot.addEventListener("click", closeAllAccordions));

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        closeAllAccordions();
      }
    });
  }, { threshold: 0.9 });

  root.querySelectorAll("#Slider-{{ section.id }} .timeline__item")
    .forEach(slide => io.observe(slide));
});